






























































































































































































import {BASE_URL, ENDPOINTS, get} from '@/api/mainApi';
import ImagePickerComponent from '@/components/ImagePickerComponent.vue';
import validators from '@/validators';
import Vue from 'vue';
import {RequestSession} from "@/interfaces/requestSession";
import {Donation} from "@/interfaces/donation/donation";
import {stepV1, stepV2} from "@/enums/donationStepOrder";
import {Donor} from "@/interfaces/donation/donor";
import {DonationCause} from "@/interfaces/organizationgroup/donationCause";
import DonationCauseAutocompleteComponent
  from "@/components/organizationgroup/donationcause/DonationCauseAutocompleteComponent.vue";
import {AttributeType} from "@/enums/attributeType";
import {DonationImage} from "@/interfaces/donation/donationImage";
import DonationCauseSelectComponent
  from "@/components/organizationgroup/donationcause/DonationCauseSelectComponent.vue";
import { DonationStepFlowVersion } from '@/enums/donationStepFlowVersion';
import StepperFlowMixin from '@/mixins/donationStepperFlowMixin';

export default Vue.extend({
  components: {
    DonationCauseSelectComponent,
    ImagePickerComponent,
    DonationCauseAutocompleteComponent
  },
  mixins: [StepperFlowMixin],
  props: {
    value: {
      type: Object as () => Donor,
    },
    form: Object
  },
  data() {
    return {
      exampleMessages: this.$t('exampleMessages'),
      lazy: true,
      loading: false,
      valid: true,
      dialog: false,
      showCause: false,
      images: [] as DonationImage[],
      defaultImage: null as DonationImage | null,
      selectedImageId: 0,
      categories: [],
      noSenderName: false,
      rules: validators(this.$t('validation')),
      attributes: {
        subjectName: AttributeType.SUBJECT_NAME,
        greeting: AttributeType.GREETING,
        donorName: AttributeType.DONOR_NAME
      },
      defaultSelectableDonationCauses: [] as DonationCause[],
      showCondolenceOptions: false,
    };
  },
  computed: {
    steps(): typeof stepV1 | typeof stepV2 {
      return this.donationStepFlowVersion == DonationStepFlowVersion.V1 ? stepV1 : stepV2;
    },
    donationDetails: {
      get(): Donation {
        return this.value
      },
      set(val: Donation) {
        this.$emit('update:value', val)
      }
    },
    greetingValue: {
      get(): string {
        return this.getAttributeValueById(this.attributes.greeting) || '';
      },
      set(value: string): void {
        this.setAttributeValueById(this.attributes.greeting, value, false);
      }
    },
    requestSession(): RequestSession {
      return this.$store.state.requestSession
    },
    donation(): Donation {
      return this.$store.state.donation
    },
    currentStep() {
      return this.$store.state.currentStep
    },
    senderName() {
      return this.donationDetails.attributeValues[2].value
    },
    nonEmptyCategories() {
      if (this.images) {
        return this.categories.filter(
            c => this.images.filter(i => i.donationImageCategory.id === c.id).length
        );
      }
      return this.categories;
    },
    hasDefaultDonationCauses(): boolean {
      return !!this.donation.donationCase
        && !!this.donation.donationCase.defaultDonationCauseIds
        && this.donation.donationCase.defaultDonationCauseIds.length > 0;
    },
    activeRequestSessionOrganizationGroupCauses(): DonationCause[] {
      if (this.requestSession.organizationGroup) {
        return this.requestSession.organizationGroup.donationCauses.filter((donationCause: DonationCause) => {
          return donationCause.active
        })
      }
      return []
    },
    hasAnyActiveRequestSessionOrganizationGroupCauses(): boolean {
      return !!this.activeRequestSessionOrganizationGroupCauses
        && this.activeRequestSessionOrganizationGroupCauses.length > 0
    },
  },
  watch: {
    currentStep(newVal, oldVal) {
      if (newVal == this.steps.DONATION_DETAILS) {
        this.setAttributeValueById(AttributeType.SUBJECT_NAME, this.donation.donationCase.caseInfo.name, false)
        this.calculateShowCause()

        if (oldVal < this.steps.DONATION_DETAILS) {
          // defaultDonationCause is only set if going forward not when coming from a stepV1 after this one
          // we do this in case DonationCase has been changed
          this.handleDonationCausesFromDonationCase()
        }
      }
    },
    greetingValue: {
      handler(newValue) {
        this.showCondolenceOptions =
          !!this.requestSession.showCondolenceOnMemorialPage &&
          !!newValue.trim().length;
      },
      immediate: true
    },
    senderName(val) {
      if (val) {
        this.noSenderName = false;
      }
    },
    noSenderName(val) {
      if (val && !this.senderName) {
        this.form.validate();
      }
    },
    selectedImageId(value) {
      if (value) {
        this.donationDetails.donationImageId = value;
      }
    },
    activeRequestSessionOrganizationGroupCauses: {
      immediate: true,
      handler(values: Array<DonationCause>) {
        if (values) {
          if (values.some((dc: DonationCause) => dc.externalOrder > 0)) {
            values.sort((dc1: DonationCause, dc2: DonationCause) =>
              dc1.externalOrder == 0 ? 1 : dc2.externalOrder == 0 ? -1
                : dc1.externalOrder - dc2.externalOrder);
          }
        }
      }
    }
  },
  created() {
    if (this.hasAnyActiveRequestSessionOrganizationGroupCauses) {
      this.fetchImages(this.requestSession.organizationGroup.id);
    }
  },
  methods: {
    calculateShowCause() {
      if (this.activeRequestSessionOrganizationGroupCauses && this.activeRequestSessionOrganizationGroupCauses.length === 1
      ) {
        this.showCause = false;
        this.donationDetails.donationCause = this.activeRequestSessionOrganizationGroupCauses[0];
      } else {
        this.showCause = true;
      }
    },
    getAttributeValueById(id: number): string {
      let attributeValue = this.donationDetails.attributeValues.find(a => a.attributeId === id);
      return attributeValue ? attributeValue.value : "";
    },
    setAttributeValueById(id: number, value, concat: boolean) {
      let attributeValue = this.donationDetails.attributeValues.find(a => a.attributeId === id);

      if (attributeValue) {
        if (concat) {
          attributeValue.value += value;
        } else {
          attributeValue.value = value
        }
      }
    },
    fetchImages(organizationGroupId) {
      get(ENDPOINTS.IMAGE_CATEGORIES, organizationGroupId) // todo - why not ENDPOINTS.IMAGE_CATEGORIES + "/" + id ???
          .then(c => {
            this.categories = c;
            this.categories.sort((a, b) => {
              // The server should return the categories from an organizationGroup first but do this do
              // be certain
              const aComp = a.organizationGroupId == null ? 0 : 1;
              const bComp = b.organizationGroupId == null ? 0 : 1;
              return bComp - aComp;
            });
          });
      get(ENDPOINTS.IMAGES, organizationGroupId) // todo - why not ENDPOINTS.IMAGES + "/" + id ???
          .then(r => this.images = r.map((image: DonationImage) => ({
            ...image,
            url: BASE_URL + image.url + '?compression=true'
          })))
          .finally(() => {
            // retrieve the default image
            this.defaultImage = this.images.find(i => i.defaultImage);

            if (this.defaultImage) {
              this.selectedImageId = this.defaultImage.id;
            } else if (this.images.length > 0) {
              // if the default image wasn't found, take the first best image (this should never happen)
              this.selectedImageId = this.images[0].id;
            } else {
              // this is disaster mode, and should absolutely not happen. We just pick the very first id, so that an image will be preselected
              this.selectedImageId = 1;
            }

            this.images.sort();
          })
    },
    selectMessage(message) {
      this.setAttributeValueById(AttributeType.GREETING, message, true);
      this.dialog = false;
    },
    validateSenderName(value) {
      if (!value && !this.noSenderName) {
        return this.$t('donationDetails.form.noSenderName.error');
      }

      return true;
    },
    t(label) {
      const $te = this.$te.bind(this);
      const $t = this.$t.bind(this);
      return $te(label) ? $t(label) : undefined;
    },
    async handleDonationCausesFromDonationCase() {
      this.loading = true
      // handle defaultDonationCause from the selected DonationCase if one is selected
      if (this.hasDefaultDonationCauses) {
        const causeIds: number[] = this.donation.donationCase.defaultDonationCauseIds
        if (causeIds.length == 1) {
          this.donationDetails.donationCause = await this.getDonationCauseWithId(this.donation.donationCase.defaultDonationCauseIds[0])
          this.fetchImages(this.donationDetails.donationCause.organizationGroup.id)
        } else if (causeIds.length > 1) {
          this.defaultSelectableDonationCauses = await this.getDonationCausesWithIds(causeIds)
        }
      }
      this.loading = false
    },
    async getDonationCauseWithId(id: number) {
      return await get(ENDPOINTS.DONATION_CAUSES + "/" + id);
    },
    async getDonationCausesWithIds(ids: number[]): Promise<DonationCause[]> {
      return await get(ENDPOINTS.DONATION_CAUSES + "?ids=" + ids.join(","));
    }
  },
});
